// extracted by mini-css-extract-plugin
module.exports = {"work":"works_work__xv0yy","title":"works_title__VzsS6","content":"works_content__1Vt_c","button":"works_button__2xSJb","CarouselProvider":"works_CarouselProvider__2gFhv"};